import {MINUTE, SECOND} from "@shared/lib/timeUnits";

export const NOTIFICATION_AUTO_INTERVAL = 5 * SECOND;

export const ORDERS_REFRESH_INTERVAL = MINUTE;